import { useState } from "react";
import { Send, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useI18n } from "../i18n/I18nContext";

export const ContactForm = ({ defaultTourType = "" }) => {
  const { t } = useI18n();
  const pick = (...vals) => vals.find((v) => typeof v === "string" && v.trim()) || "";
  const tourBusiness = pick(t.form.tourBusiness, "Бизнес / Бенчмарк", "Business / Benchmark");
  const tourTravel = pick(t.form.tourTravel, t.nav?.travel, "Путешествия", "Travel");
  const tourRetreat = pick(t.form.tourRetreat, t.nav?.retreat, "Ретрит", "Retreat");
  const tourFilming = pick(t.form.tourFilming, t.nav?.filming, "Съёмки", "Production");
  const tourOther = pick(t.form.tourOther, "Другое", "Other");

  const [form, setForm] = useState({
    name: "",
    contact: "",
    tour_type: defaultTourType || tourBusiness,
    comment: "",
  });
  const [loading, setLoading] = useState(false);

  const tourOptions = Array.from(
    new Set([tourBusiness, tourTravel, tourRetreat, tourFilming, tourOther].filter(Boolean))
  );

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.contact.trim()) {
      toast.error(t.common.submitError);
      return;
    }
    setLoading(true);
    try {
      await api.post("/submissions", form);
      toast.success(t.common.submitSuccess);
      setForm({ name: "", contact: "", tour_type: form.tour_type, comment: "" });
    } catch (err) {
      toast.error(t.common.submitError);
    } finally {
      setLoading(false);
    }
  };

  const inputBase =
    "w-full bg-midnight-3 border border-white/10 focus:border-coral py-3 px-4 text-white placeholder:text-white/30 outline-none transition-colors font-display";
  const labelBase = "block overline mb-2";

  return (
    <form
      onSubmit={submit}
      data-testid="contact-form"
      className="space-y-6"
    >
      <div>
        <label className={labelBase}>{t.form.name}</label>
        <input
          data-testid="contact-name"
          required
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
          className={inputBase}
        />
      </div>
      <div>
        <label className={labelBase}>{t.form.contact}</label>
        <input
          data-testid="contact-contact"
          required
          value={form.contact}
          onChange={(e) => setForm({ ...form, contact: e.target.value })}
          className={inputBase}
        />
      </div>
      <div>
        <label className={labelBase}>{t.form.tourType}</label>
        <select
          data-testid="contact-tour-type"
          value={form.tour_type}
          onChange={(e) => setForm({ ...form, tour_type: e.target.value })}
          className={`${inputBase} cursor-pointer`}
        >
          {tourOptions.map((o) => (
            <option key={o} value={o} className="bg-midnight-3 text-white">
              {o}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label className={labelBase}>{t.form.comment}</label>
        <textarea
          data-testid="contact-comment"
          rows={4}
          value={form.comment}
          onChange={(e) => setForm({ ...form, comment: e.target.value })}
          className={`${inputBase} resize-none`}
        />
      </div>
      <button
        type="submit"
        data-testid="contact-submit"
        disabled={loading}
        className="btn-primary !py-4 !px-7 mt-4 disabled:opacity-50"
      >
        {loading ? (
          <>
            <Loader2 size={16} className="animate-spin" /> {t.common.sending}
          </>
        ) : (
          <>
            {t.common.send} <Send size={14} />
          </>
        )}
      </button>
    </form>
  );
};
